import { useIntersectionObserver } from '@ab-core-functions/observer';
import { Availabilities } from '@ab-core/availabilities';
import type { FC } from 'react';
import React from 'react';
import {
    IconsContainer,
    IdsContainer,
    ImageContainer,
    NameContainer,
    OrderContainer,
    TagsContainer
} from '../../components';
import type { DefaultScalableProductCardProps } from '../index';
import { getScalablePropsFromDefaultProps } from '../utils';
import { StyledImageWrapper } from './index.styled';

export const ScalableProductCardMobile: FC<DefaultScalableProductCardProps> = (props) => {
    const { ref, isVisible } = useIntersectionObserver<HTMLDivElement>({
        threshold: 0.5,
        freezeOnceVisible: true
    });

    const { image, ids, icons, name, availability, order, tags } = getScalablePropsFromDefaultProps({
        ...props,
        isVisible
    });

    return (
        <>
            <div ref={ref} className="flex gap-small3">
                <StyledImageWrapper>
                    <ImageContainer isSmartphone {...image} />
                </StyledImageWrapper>
                <div>
                    <IdsContainer {...ids} />
                    <IconsContainer {...icons} />
                    <NameContainer {...name} />
                    <div className="mt-small">
                        <TagsContainer {...tags} />
                    </div>
                </div>
            </div>
            <div>
                <Availabilities {...availability} />
            </div>
            <OrderContainer {...order} showPrices={false} isSmartphone />
        </>
    );
};
